import { render } from "./OpenCloseShopApplyDetails.vue?vue&type=template&id=0a19ebe8&scoped=true&ts=true"
import script from "./OpenCloseShopApplyDetails.vue?vue&type=script&lang=ts"
export * from "./OpenCloseShopApplyDetails.vue?vue&type=script&lang=ts"

import "./OpenCloseShopApplyDetails.vue?vue&type=style&index=0&id=0a19ebe8&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a19ebe8"]])

export default __exports__